import React from 'react';
import { FONT_BODY } from './theme';
import { NAV_LINKS } from './data';
import { Logo, CtaButton } from './ui';
import { ArrowIcon } from './icons';

const SiteHeader: React.FC<{ onEarlyAccess: () => void }> = ({ onEarlyAccess }) => (
  <header
    style={{
      position: 'sticky',
      top: 0,
      zIndex: 50,
      background: 'rgba(255,255,255,.88)',
      backdropFilter: 'blur(18px)',
      borderBottom: '1px solid #EDF3FC',
    }}
  >
    <div
      style={{
        maxWidth: 1180,
        margin: '0 auto',
        padding: '13px clamp(16px,4vw,30px)',
        display: 'flex',
        alignItems: 'center',
        gap: 18,
        flexWrap: 'wrap',
      }}
    >
      <a href="#top" style={{ display: 'flex', alignItems: 'center', gap: 10, flex: 'none' }}>
        <Logo width={163} height={30} />
      </a>
      <nav
        style={{
          display: 'flex',
          gap: 0,
          margin: '0 auto',
          flexWrap: 'nowrap',
          justifyContent: 'center',
          minWidth: 0,
          overflowX: 'auto',
          scrollbarWidth: 'none',
        }}
      >
        {NAV_LINKS.map((l) => (
          <a
            key={l.href}
            href={l.href}
            className="sm1p-navlink"
            style={{
              font: `500 14px ${FONT_BODY}`,
              color: '#334155',
              padding: '9px 12px',
              borderRadius: 9,
              whiteSpace: 'nowrap',
              flex: 'none',
            }}
          >
            {l.label}
          </a>
        ))}
      </nav>
      <CtaButton variant="header" onClick={onEarlyAccess} style={{ flex: 'none' }}>
        GET EARLY ACCESS
        <ArrowIcon size={15} />
      </CtaButton>
    </div>
  </header>
);

export default SiteHeader;
